import React from 'react';
import styles from './moderation-pending-chats.module.scss';
import { Typography } from '@/ui-kit';
import { ModerationPendingIcon } from '@/assets/icons';

interface Props {}

export const ModerationPendingChats: React.FC<Props> = () => {
    return (
        <div className={styles.wrapper}>
            <ModerationPendingIcon className={styles.remoderationCardContentIcon} />
            <Typography
                fontWeight="semibold"
                center
                fontFamily="SFProText"
                className={styles.title}>
                Твоя анкета на проверке
            </Typography>
            <Typography
                center
                fontFamily="SFProText"
                className={styles.text}>
                Сейчас проверяем твои данные, обычно это занимает немного времени
            </Typography>
        </div>
    );
};
